import React, { useReducer } from "react";
import { Reducer as reducer } from "./Reducer";
import { Actions as actions } from "./Actions";

const initialValue = {
  enterpriseId: null,
  paymentMethod: null,
  billingInformation: null,
};

const context = React.createContext();

const Context = ({ enterpriseId, children }) => {
  initialValue.enterpriseId = enterpriseId;
  const [state, dispatch] = useReducer(reducer, initialValue);

  return (
    <context.Provider value={{ state, dispatch, actions }}>
      {children}
    </context.Provider>
  );
};

export const useContext = () => React.useContext(context);
export default Context;
